"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DailyCampaignCostsResponse = exports.DailyCampaignCostResult = exports.DailyCampaignCostBreakdown = exports.CalculateDailyCampaignCostsDto = exports.DAILY_CAMPAIGN_COST_MAX_DISPLAYS = void 0;
const class_validator_1 = require("class-validator");
exports.DAILY_CAMPAIGN_COST_MAX_DISPLAYS = 2_000;
class CalculateDailyCampaignCostsDto {
    displayIds;
    durationSeconds = 10;
    referenceDate;
}
exports.CalculateDailyCampaignCostsDto = CalculateDailyCampaignCostsDto;
__decorate([
    (0, class_validator_1.IsArray)(),
    (0, class_validator_1.ArrayMinSize)(1),
    (0, class_validator_1.ArrayMaxSize)(exports.DAILY_CAMPAIGN_COST_MAX_DISPLAYS),
    (0, class_validator_1.IsString)({ each: true }),
    __metadata("design:type", Array)
], CalculateDailyCampaignCostsDto.prototype, "displayIds", void 0);
__decorate([
    (0, class_validator_1.IsInt)(),
    (0, class_validator_1.Min)(10),
    (0, class_validator_1.Max)(10),
    __metadata("design:type", Number)
], CalculateDailyCampaignCostsDto.prototype, "durationSeconds", void 0);
__decorate([
    (0, class_validator_1.IsISO8601)(),
    __metadata("design:type", String)
], CalculateDailyCampaignCostsDto.prototype, "referenceDate", void 0);
class DailyCampaignCostBreakdown {
    /** Commercial reproductions planned for each booked operating hour. */
    reproductionsPerHour;
    operatingHourCount;
    plannedReproductions;
    /** CPM selected by the pricing strategy after category/display fallbacks. */
    effectiveCpm;
    /** Average people attributed to each priced hour when audience data is available. */
    averageAudiencePerHour;
    /** People per day used by the reproduction-based audience multiplier. */
    dailyAudience;
    /** Bounded multiplier derived from daily audience. */
    audienceMultiplier;
    /** Combined contextual factor after applying its safety bounds. */
    contextualMultiplier;
    /** Combined contextual factor before applying its safety bounds. */
    rawContextualMultiplier;
    /** Technical hourly safeguard; it is not a pricing input. */
    minimumHourlyPrice;
    minimumAppliedHours;
}
exports.DailyCampaignCostBreakdown = DailyCampaignCostBreakdown;
class DailyCampaignCostResult {
    displayId;
    status;
    amountWithTax;
    currency = "EUR";
    /** The display-local date used for pricing, formatted as YYYY-MM-DD. */
    pricingDate;
    /** The display-local date corresponding to referenceDate, formatted as YYYY-MM-DD. */
    referenceLocalDate;
    /** Playable hours as seconds from local midnight. */
    operatingHours = [];
    /** Additive audit data for explaining the daily estimate. */
    pricingBreakdown;
    reason;
}
exports.DailyCampaignCostResult = DailyCampaignCostResult;
class DailyCampaignCostsResponse {
    results;
}
exports.DailyCampaignCostsResponse = DailyCampaignCostsResponse;
